<template>
  <div>
    <div class="renewing-membership membership-options confirm-electoral d-none d-md-block">
      <div class="row">
        <div class="col-md-6">
          <h6>Payment details</h6>
          <el-form
            :model="card"
            :rules="formValidation"
            ref="form-credit"
            class="form-credit"
            v-loading="validating"
            element-loading-text="Payment processing..."
          >
            <el-row>
              <el-form-item :inline-message="true" prop="name">
                <p>Name on the card</p>
                <el-input
                  v-model="card.name"
                  placeholder="i.e. John Doe"
                ></el-input>
              </el-form-item>
            </el-row>

            <el-row>
              <el-form-item :inline-message="true" prop="number">
                <p>Card number</p>
                <el-input
                  v-model="card.number"
                  maxlength="16"
                  prefix-icon="el-icon-bank-card"
                  placeholder="Card number"
                ></el-input>
              </el-form-item>
            </el-row>

            <el-row>
              <el-form-item>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <p>Expiry date</p>
                    <el-form-item :inline-message="true" prop="date">
                      <el-input
                        @input="validateInputDate"
                        maxlength="5"
                        placeholder="MM/YY"
                        v-model="card.date"
                        prefix-icon="el-icon-date"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <p>CVV</p>
                    <el-form-item :inline-message="true" prop="cvv">
                      <el-input
                        v-model="card.cvv"
                        placeholder="CVV"
                        maxlength="4"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <div class="renewal-btn d-flex flex-wrap" v-if="!validating">
      <el-button type="secondary" @click="back"><i class="el-icon-back"></i> BACK</el-button>
      <el-button type="primary" @click="donate">PAY <i class="el-icon-arrow-right el-icon-right"></i></el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  data() {
    const validateNum = (val) => {
      const reg = /^\d+$/;
      return reg.test(val);
    };

    const validateCardNumber = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error(
            this.paymentValidationMsg["missing-card-number"]
          )
        );
      }

      if (!this.$validCreditCardNumber(value)) {
        return callback(new Error("Must be a valid credit card number"));
      } else {
        return callback();
      }
    };

    const validateDate = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error(
            this.paymentValidationMsg["missing-card-date"]
          )
        );
      }

      if (!validateNum(value.replace('/', ''))) {
        return callback(new Error("Must be a valid date"));
      }

      const dateArr = value.split('/');
      if ((dateArr[0].length === 2 && parseInt(dateArr[0]) === 0) || parseInt(dateArr[0]) > 12) {
        return callback(new Error("Must be a valid month"));
      } else {
        return callback();
      }
    };

    const validateCvvNumber = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error(
            this.paymentValidationMsg["missing-card-cvv"]
          )
        );
      }

      if (!validateNum(value)) {
        return callback(new Error("Must be a valid CVV"));
      } else {
        return callback();
      }
    };

    return {
      validating: false,
      card: {
        name: "",
        number: "",
        date: "",
        cvv: ""
      },
      formValidation: {
        name: {
          required: true,
          message: "",
          trigger: "blur",
        },
        number: [
          {
            validator: validateCardNumber,
            trigger: "change",
          }
        ],
        date: [
          {
            validator: validateDate,
            trigger: "change",
          }
        ],
        cvv: [
          {
            validator: validateCvvNumber,
            trigger: "change",
          },
        ],
      },
    }
  },
  computed: {
    ...mapGetters('renewal', ['paymentValidationMsg']),
  },
  mounted() {
    this.setValidation();
  },
  methods: {
    ...mapMutations('renewal', ['setStep']),
    ...mapActions('renewal', ['renewalPayment']),

    back() {
      this.setStep(3);
    },
    setValidation() {
      this.formValidation.name.message = this.paymentValidationMsg["missing-card-name"];
      this.formValidation.number.message = this.paymentValidationMsg["missing-card-number"];
      this.formValidation.date.message = this.paymentValidationMsg["missing-card-date"];
      this.formValidation.cvv.message = this.paymentValidationMsg["missing-card-cvv"];
    },
    validateInputDate(value) {
      if (value.length > 2 && !value.includes("/")) {
        this.card.date = value.substring(0, 2) + "/" + value.substring(2);
      }
    },
    donate() {
      this.$refs["form-credit"].validate((valid) => {
        if (valid) {
          this.validating = true;
          const payload = {
            payment_type : 'cc',
            card_type : 'NA',
            card_holder : this.card.name,
            card_number : this.card.number,
            expire_month : this.card.date.substring(0, 2),
            expire_year : `20${this.card.date.substring(this.card.date.length - 2)}`,
            ccv : this.card.cvv,
          }
          this.renewalPayment(payload).then((res) => {
            this.validating = false;
            if (res.response_status === 'success') {
              this.setStep(5);
            }
          });
        } else {
          return false;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/fonts/stylesheet.css';

.form-credit {
  p {
    margin: 4px 0px;
    font-size: 12px;
    line-height: normal;

    @media (min-width: 700px) {
      font-size: 15px;
    }
  }

  .el-row {
    margin-bottom: 10px;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-form-item__content {
    font-family: "Gotham Narrow Light";
    font-weight: bold;

    p {
      font-size: 14px;
      margin-bottom: 0.5rem!important;
    }
  }
}
</style>
